export default {"src":"/_next/static/media/positionOpposition.3bc1fc26.svg","height":400,"width":413,"blurWidth":0,"blurHeight":0};